import React from "react";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
export default (WrappedComponent, Wdata) => {
  const Index = ({ getItem, images, loading, error, id, filesCount }) => {
    return (
      <WrappedComponent
        onClick={() => getItem(id)}
        filesCount={filesCount}
        files={images}
        loading={loading}
        error={error}
      />
    );
  };
  const mapStateToProps = store => {
    const { reducer_name } = Wdata;
    return {
      images: store[reducer_name].images,
      loading: store[reducer_name].imagesLoading,
      error: store[reducer_name].imagesError
    };
  };
  const mapDispatchToProps = dispatch => {
    return {
      getItem: id => {
        dispatch(Wdata.getItem(id));
      }
    };
  };

  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Index)
  );
};
